import _ from "lodash";
import { getBehaviourColourForPosition } from "@signolteam/shared/colours";
import { Tag } from "@src/components/atoms";
import { DonationAmountOperator } from "../../../components/atoms/DonationAmount";

/** Tags of per-behaviour donation totals, eg. "ABC total: USD 123"
 *
 * @param {{
 *   customerCode: string,
 *   customerBehaviours: Array<{behaviourAcronym: string, behaviourName: string, order: number}>
 *   operatorPeriodImpact: Array<{ behaviourGroupCode: string, behaviourGroupId: string, donationTotal: number, goalTargetAchievedOperator: boolean, periodKey: string, sumSavingsKg: number }>,
 * }} props
 */
const PersonalAllTimeDonationTags = ({
  customerBehaviours,
  operatorPeriodImpact,
}) => {
  const bvrAcronymToOrder = customerBehaviours.reduce((acc, obj) => {
    acc[obj.behaviourAcronym] = obj.order;
    return acc;
  }, {});

  const savingsPerBvr = _(operatorPeriodImpact)
    .groupBy("behaviourGroupCode")
    .map((items, groupCode) => {
      const order = bvrAcronymToOrder[groupCode];
      const totalDonations = _.sumBy(items, "donationTotal");
      return {
        behaviourGroupCode: groupCode,
        order,
        totalDonations,
      };
    })
    .orderBy("order")
    .value();

  const tags = savingsPerBvr.map((item) => (
    <Tag
      color={getBehaviourColourForPosition(item.order).name}
      block
      key={item.behaviourGroupCode}
      fullWidth
    >
      <div className="flex justify-between">
        {`${item.behaviourGroupCode} total:`}
        <strong>
          <DonationAmountOperator amount={item.totalDonations} />
        </strong>
      </div>
    </Tag>
  ));

  return (
    <div className="flex flex-col gap-2 text-left justify-start">{tags}</div>
  );
};

export default PersonalAllTimeDonationTags;
